import { render, staticRenderFns } from "./ReferenceAutocomplete.vue?vue&type=template&id=36cc4ff0&scoped=true&"
import script from "./ReferenceAutocomplete.vue?vue&type=script&lang=js&"
export * from "./ReferenceAutocomplete.vue?vue&type=script&lang=js&"
import style0 from "./ReferenceAutocomplete.vue?vue&type=style&index=0&id=36cc4ff0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36cc4ff0",
  null
  
)

export default component.exports